<template>
	<el-row class="points-show">
		<el-col :span="23">
			会员管理（开发中）
		</el-col>
		<el-divider></el-divider>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	export default {
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	};
</script>
